import React from 'react';

import { CheckboxGroupContextProps } from './CheckboxGroup.types';

const CheckboxGroupContext = React.createContext<CheckboxGroupContextProps | undefined>(undefined);

export default CheckboxGroupContext;
